import React from 'react';
import { BookText } from 'lucide-react';
import './BibleVerse.css';

const BibleVerse = ({ verse, reference }) => {
  return (
    <section className="bible-verse">
      <div className="container">
        <div className="verse-icon">
          <BookText size={40} />
        </div>
        <blockquote>
          {verse}
          <cite>{reference}</cite>
        </blockquote>
      </div>
    </section>
  );
};

export default BibleVerse;
